import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('order-success', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./order-success')
    ),
);
